import React, { useEffect, useState } from "react";
import "simplebar-react/dist/simplebar.min.css";
import { Col, Row, Table } from "react-bootstrap";
import ImageViewer from "../../components/ImageViewer";
import { getAllPreviousItemsStockList, getFundRequest4LowPriceOnItemId } from "../../services/contractorApi";
import { useTranslation } from "react-i18next";
import { GroupTable } from "../../components/GroupTable";
import { Badge } from "react-bootstrap";
import { BsDashLg, BsPlusLg } from "react-icons/bs"
import { UserDetail } from "../../components/ItemDetail";
import { ItemRemarksCell, useItemRemarkMap } from "../../components/ItemRemarks";
import { useActionGate } from "../../utils/menuNodes";
import { formatAmountINR, to3 } from "../../utils/helper";

export const ViewStockRequestDetails = ({ edit }) => {
  // every item's Request / Approve / Transfer remarks, in each table's Remarks column
  // The Transfer line's Transaction ID / Remark — and the item remarks — are
  // edited here, in the item tables, with the "Edit Transaction ID / Remark"
  // right of the Transferred tab (the list's separate Edit button is gone).
  const canActOn = useActionGate("/StockManagement");
  const canEditTransfer = canActOn("stock-transfer-transferred", "edit_details", false);
  const itemRemarks = useItemRemarkMap("stock", edit?.id);
  const { t } = useTranslation();
  let statusColor = "";
  let statusText = "";
   const [collapsedRows, setCollapsedRows] = useState([]);
   const [item, setItems] = useState([]);
    const [previousFundAmountData, setPreviousFundAmountData] = useState([]);
    const toggleRow = (index) => {
      setCollapsedRows((prev) => {
        const isCollapsed = prev.includes(index);
        if (isCollapsed) {
          return prev.filter((rowIndex) => rowIndex !== index);
        } else {
          return [...prev, index];
        }
      });
    };

  switch (+edit?.status) {
    case 0:
      statusColor = "#D9512C"; // Pending
      statusText = "Pending";
      break;
    case 1:
      statusColor = "green"; // Approved
      statusText = "Approved";
      break;
    case 2:
      statusColor = "red"; // Reject
      statusText = "Rejected";
      break;
    case 3:
      statusColor = "orange"; // Hold
      statusText = "On Hold";
      break;
    case 4:
      statusColor = "blue"; // Partial
      statusText = "Partial";
      break;
    case 5:
      statusColor = "green"; // Done
      statusText = "Done";
      break;
  }

  const [allOldItems, setAllOldItems] = useState([]);
  const [lowPrice, setLowPrice] = useState({});

  useEffect(() => {
    console.log("Approved Data 👉", edit?.approved_data);
    fetchAllPreviousItem(edit?.requested_for);
    const fetchLowPriceForItems = async (items) => {
      for (const itm of items || []) {
        const hsncode = itm?.item_name?.hsncode;
        if (hsncode && !lowPrice[hsncode]) {
          const res = await getFundRequest4LowPriceOnItemId(hsncode, "stock", edit?.requested_for);
          if (res.status) {
            setLowPrice((prev) => ({ ...prev, [hsncode]: res.data }));
          }
        }
      }
    };
    fetchLowPriceForItems(edit?.request_stock?.request_stock);
    fetchLowPriceForItems(edit?.approved_data?.[0]?.request_stock);
    fetchLowPriceForItems(edit?.transfer_stocks?.request_stock);
  }, [edit]);

  const fetchAllPreviousItem = async (id) => {
    const res = await getAllPreviousItemsStockList(id);
    if (res.status) {
      setAllOldItems(res.data);
    } else {
      setAllOldItems([]);
    }
  };
  console.log("Request Date 👉", edit?.request_date);

  return (
    <>
      <Row className="g-3">
        {/* <Col md={12}>
          <GroupTable data={allOldItems} />
        </Col> */}
          {/* ----------- Left Card: Request By Details ----------- */}
          <Col md={6}>
                <div className="p-20 shadow rounded h-100">
                  <strong className="text-secondary">{t("Request By Details")}</strong>
                  <div className="mt-2">
                    <table className="table-sm table">
                      <tbody>
                        <tr>
                          <th className="align-middle">{t("Username")} :</th>
                          <td>
                            <UserDetail
                              img={edit?.requested_for_image}
                              name={edit?.requested_for_name}
                              unique_id={edit?.requested_for_employee_id}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Current Balance")} :</th>
                          <td style={{ color: "green", fontWeight: "600" }}>
                            {formatAmountINR(edit?.closing_stock_balance || 0)}
                          </td>
                        </tr>
                        {/* Amount - shown only for Pending (0) and Rejected (2) */}
                        {(edit?.status == 0 || edit?.status == 2) && (
                          <tr>
                            <th>
                              {t(edit?.status == 0 ? "Request Amount" : "Rejected Amount")}{" "}:
                            </th>
                            <td style={{ color: "green", fontWeight: "600" }}>
                              {formatAmountINR(edit?.total_request_amount ? edit?.total_request_amount : edit?.total_sum_of_request_stock || 0)}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <th>{t("Request Date")} :</th>
                          <td>{edit?.request_date ?? "--"}</td>
                        </tr>
                        {/* Approved By / Rejected By - shown when status is approved or rejected */}
                        {(edit?.status == 1 || edit?.status == 2) && (
                          <tr>
                            <th>
                              {edit?.status == 2 ? t("Rejected By") : t("Approved By")}{" "}:
                            </th>
                            <td>{edit?.approved_by_name ?? "--"}</td>
                          </tr>
                        )}
                        {/* Approved Date / Reject Date - shown when status is approved or rejected */}
                        {(edit?.status == 1 || edit?.status == 2) && (
                          <tr>
                            <th>
                              {edit?.status == 2 ? t("Reject Date") : t("Approved Date")}{" "}:
                            </th>
                            <td>{edit?.approved_at ?? "--"}</td>
                          </tr>
                        )}
                        {/* Approved Amount - shown when approved, partial, or done */}
                        {(edit?.status == 1 || edit?.status == 4 || edit?.status == 5) && (
                          <tr>
                            <th>{t("Approved Amount")} :</th>
                            <td style={{ color: "green", fontWeight: "600" }}>
                              {formatAmountINR(edit?.approved_data?.[0]?.request_stock?.reduce(
                                (total, item) =>
                                  total + (item?.approve_price || 0) * (item?.approve_quantity || 0),
                                0
                              ) || 0)}
                            </td>
                          </tr>
                        )}
                        {/* Transferred Amount - shown when partial or done */}
                        {(edit?.status == 4 || edit?.status == 5) && (
                          <tr>
                            <th>
                              {edit?.status == 4
                                ? t("Partially Transferred Amount")
                                : t("Transferred Amount")}{" "}:
                            </th>
                            <td style={{ color: "green", fontWeight: "600" }}>
                              {formatAmountINR(edit?.amount_trasnferred || 0)}
                            </td>
                          </tr>
                        )}
                        {/* Rescheduled Amount - shown when partial or done */}
                        {(edit?.status == 5 || edit?.status == 4) && (
                          <tr>
                            <th>{t("Rescheduled Amount")} :</th>
                            <td style={{ color: "green", fontWeight: "600" }}>
                              {formatAmountINR(edit?.rescheduled_amount || 0)}
                            </td>
                          </tr>
                        )}
                        {/* Remaining Transfer Amount - shown when approved, partial, or done */}
                        {/* {(edit?.status == 1 || edit?.status == 4 || edit?.status == 5) && (
                          <tr>
                            <th>{t("Remaining Transfer Amount")} :</th>
                            <td style={{ color: "green", fontWeight: "600" }}>
                              ₹ {(edit?.approved_data?.[0]?.request_stock?.reduce(
                                (total, item) =>
                                  total + (item?.approve_price || 0) * (item?.approve_quantity || 0),
                                0
                              ) || 0) - (edit?.amount_trasnferred || 0)}
                            </td>
                          </tr>
                        )} */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>

              {/* ----------- Right Card: Stock Details ----------- */}
              <Col md={6}>
                <div className="p-20 shadow rounded h-100">
                  <strong className="text-secondary">{t("Stock Details")}</strong>
                  <div className="mt-2">
                    <table className="table-sm table">
                      <tbody>
                        {/* Status - always shown */}
                        <tr>
                          <th>{t("Status")} :</th>
                          <td style={{ color: statusColor }}>{statusText}</td>
                        </tr>
                        {/* Total Stock Limit */}
                        <tr>
                          <th>{t("Total Stock Limit")} :</th>
                          <td style={{ color: "green", fontWeight: "600" }}>
                            {edit?.Total_Stock_Limit != null ? formatAmountINR(edit?.Total_Stock_Limit) : "--"}
                          </td>
                        </tr>
                        {/* the user's whole stock, from the ledger */}
                        <tr>
                          <th>{t("Total Stock Received")} :</th>
                          <td style={{ color: "green", fontWeight: "600" }}>
                            {formatAmountINR(edit?.total_stock_transferred ?? 0)}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Current Stock Balance")} :</th>
                          <td style={{ color: "green", fontWeight: "600" }}>
                            {formatAmountINR(edit?.Current_stock_Balance ?? 0)}
                          </td>
                        </tr>
                        {/* Remaining Stock Limit */}
                        <tr>
                          <th>{t("Remaining Stock Limit")} :</th>
                          <td style={{ color: "green", fontWeight: "600" }}>
                            {edit?.Remaining_Stock_Limit ? formatAmountINR(edit?.Remaining_Stock_Limit) : "--"}
                          </td>
                        </tr>
                        {/* Total Amount Punched */}
                        <tr>
                          <th>{t("Total Amount Punched")} :</th>
                          <td style={{ color: "green", fontWeight: "600" }}>
                            {formatAmountINR(edit?.total_amount_punched ?? 0)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>

        {/* {(edit?.request_stock?.request_stock?.length > 0 ||
          edit?.request_stock?.new_request_stock?.length > 0) && (
          <Col md={12}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary">
                {t("Request Stock Field")}
              </strong>
              <div className="mt-2">
                <table className="table-sm table">
                  <tbody>
                    <tr>
                      <th>{t("Status")} :</th>
                      <td style={{ color: statusColor }}>{statusText}</td>
                    </tr>
                    <tr>
                      <th>{t("request tax type")} :</th>
                      <td>
                        {edit?.request_tax_type == "1"
                          ? "Item Wise"
                          : "Overall Price"}
                      </td>
                    </tr>
                    {edit?.request_tax_type == "2" ? (
                      <>
                        <tr>
                          <th>{t("Gst Type")} :</th>
                          <td>{edit?.gst_type}</td>
                        </tr>
                        <tr>
                          <th>{t("Gst %")} :</th>
                          <td>{edit?.gst_percent}</td>
                        </tr>
                      </>
                    ) : null}
                    <tr>
                      <th className="align-middle">{t("Requested For")} :</th>
                      <td>
                        <ImageViewer
                          src={
                            edit?.requested_for_image
                              ? `${process.env.REACT_APP_API_URL}${edit?.requested_for_image}`
                              : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                          }
                        >
                          <img
                            width={35}
                            height={35}
                            className="my-bg object-fit p-1 rounded-circle"
                            src={
                              edit.requested_for_image
                                ? `${process.env.REACT_APP_API_URL}${edit.requested_for_image}`
                                : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                            }
                          />{" "}
                        </ImageViewer>
                        {edit?.requested_for_name} -{" "}
                        {edit?.requested_for_employee_id}
                      </td>
                    </tr>
                    <tr>
                      <th>{t("request date")} :</th>
                      <td>{edit?.request_date}</td>
                    </tr>
                    <tr>
                      <th className="align-middle">
                        {t("Uploaded bill image")} :
                      </th>
                      <td>
                        <ImageViewer
                          src={
                            edit.request_stock_images?.[0]?.item_image
                              ? `${process.env.REACT_APP_API_URL}${edit?.request_stock_images?.[0]?.item_image}`
                              : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                          }
                        >
                          <img
                            width={50}
                            height={50}
                            className="my-bg object-fit p-1 rounded"
                            src={
                              edit.request_stock_images?.[0]?.item_image
                                ? `${process.env.REACT_APP_API_URL}${edit?.request_stock_images?.[0]?.item_image}`
                                : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                            }
                          />{" "}
                        </ImageViewer>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Col>
        )} */}

        {edit?.request_stock?.request_stock?.length > 0 && (
          <Col md={12}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary d-block mb-2" style={{ fontSize: "16px", borderBottom: "2px solid #e9ecef", paddingBottom: "8px" }}>{t("Requested Item")}</strong>
              <div className="mt-2" style={{ overflowX: "auto", maxHeight: "400px", overflowY: "auto" }}>
                <Table className="table Roles table-bordered text-nowrap" style={{ minWidth: "1600px" }}>
                  <thead style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "#e9ecef", whiteSpace: "nowrap" }}>
                    <tr className="text-center">
                      <th style={{ width: "60px" }}>{t("Sr No.")}</th>
                      <th style={{ minWidth: "280px" }}>{t("Item Name")}</th>
                      <th style={{ minWidth: "100px" }}>{t("HSN Code")}</th>
                      <th style={{ minWidth: "100px" }}>{t("Brand")}</th>
                      {edit?.request_tax_type == "1" ? (
                        <>
                          <th style={{ minWidth: "90px" }}>{t("Gst Type")}</th>
                          <th style={{ minWidth: "70px" }}>{t("Gst %")}</th>
                        </>
                      ) : null}
                      <th style={{ minWidth: "110px" }}>{t("Prev user stock")}</th>
                      <th style={{ minWidth: "110px" }}>{t("prev item price")}</th>
                      <th style={{ minWidth: "110px" }}>{t("current price")}</th>
                      <th style={{ minWidth: "100px" }}>{t("request stock")}</th>
                      <th style={{ minWidth: "100px" }}>{t("total price")}</th>
                      <th style={{ minWidth: "100px" }}>{t("Lowest Rate")}</th>
                      <th style={{ minWidth: "120px" }}>{t("Supplier")}</th>
                      <th style={{ width: "70px" }}>{t("Action")}</th>
                      <th>{t("Remarks")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {edit?.request_stock?.request_stock?.map((itm, idx) => (
                      <>
                      <tr key={idx} className="align-middle">
                        <td className="text-center">{idx + 1}</td>
                        <td>
                            <div className="d-flex align-items-center">
                              <ImageViewer
                                src={
                                  itm.item_name?.image
                                    ? `${process.env.REACT_APP_API_URL}/${itm.item_name?.image}`
                                    : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                }
                              >
                                <img
                                  src={
                                    itm.item_name?.image
                                      ? `${process.env.REACT_APP_API_URL}/${itm.item_name?.image}`
                                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                  }
                                  className="avatar me-2"
                                />
                              </ImageViewer>
                              <span className="small d-grid">
                                <span>{itm.item_name?.label}</span>
                                <span className="text-gray">
                                  {itm.item_name?.unique_id
                                    ? `(${itm.item_name?.unique_id})`
                                    : "-"}
                                </span>
                              </span>
                            </div>
                        </td>
                        <td>{itm.item_name?.hsncode || "-"}</td>
                        <td>{itm.rate?.label || "-"}</td>
                        {edit?.request_tax_type == "1" ? (
                          <>
                            <td>{itm.gst_id?.label ?? "--"}</td>
                            <td>{itm?.gst_percent ?? "--"}</td>
                          </>
                        ) : null}
                        <td>{to3(itm.prev_user_stock)}</td>
                        <td>{formatAmountINR(itm.prev_item_price)}</td>
                        <td>{formatAmountINR(itm.current_item_price)}</td>
                        <td>{to3(itm.request_quantity)}</td>
                        <td>{formatAmountINR(itm.total_price)}</td>
                        <td>
                          {(() => {
                            const prices = lowPrice[itm.item_name?.hsncode];
                            if (!prices || prices.length === 0) return "-";
                            const minItem = prices.reduce((min, item) =>
                              !min || +item.item_rate < +min.item_rate ? item : min, null
                            );
                            return minItem ? formatAmountINR(minItem.item_rate) : "-";
                          })()}
                        </td>
                        <td>
                          {(() => {
                            const prices = lowPrice[itm.item_name?.hsncode];
                            if (!prices || prices.length === 0) return "-";
                            const minItem = prices.reduce((min, item) =>
                              !min || +item.item_rate < +min.item_rate ? item : min, null
                            );
                            return minItem?.supplier_name || "-";
                          })()}
                        </td>
                        <td className="text-center">
                          <span
                            className={`cursor-pointer text-${
                              collapsedRows.includes(`requested_${idx}`) ? "danger" : "green"
                            }`}
                            onClick={() => toggleRow(`requested_${idx}`)}
                          >
                            {collapsedRows.includes(`requested_${idx}`) ? (
                              <BsDashLg fontSize={"large"} />
                            ) : (
                              <BsPlusLg fontSize={"large"} />
                            )}
                          </span>
                        </td>
                        <td>
                          <ItemRemarksCell remarks={itemRemarks} path={`0:request_stock:${idx}`} stages={["raised", "approved", "transferred"]} canEdit={canEditTransfer} canEditTransfer={canEditTransfer} />
                        </td>
                      </tr>
                       {collapsedRows.includes(`requested_${idx}`) && (
                        <tr>
                          <td className="text-start" colSpan="12" style={{ backgroundColor: "#f0f7ff", padding: "10px" }}>
                            <span className="fw-bold text-primary">{t("Description")}:</span>{" "}
                            {itm.description}
                          </td>
                        </tr>
                      )}
                      </>
                      
                    ))}
                    <tr>
                      <td colSpan={edit?.request_tax_type == "1" ? 6 : 4}></td>
                      <td colSpan={1}>{t("total")}</td>
                      <td className="text-start ">
                        <b>{to3(edit?.total_request_quantity)}</b>
                      </td>

                      <td className="text-start fs-6">
                        <b>{formatAmountINR(edit?.total_sum_of_request)}</b>
                      </td>

                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        )}

        {edit?.request_stock?.new_request_stock?.length > 0 && (
          <Col md={12}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary d-block mb-2" style={{ fontSize: "16px", borderBottom: "2px solid #e9ecef", paddingBottom: "8px" }}>
                {t("New Request Item")}
              </strong>
              <div className="mt-2" style={{ overflowX: "auto", maxHeight: "400px", overflowY: "auto" }}>
                <Table className="table Roles table-bordered text-nowrap" style={{ minWidth: "600px" }}>
                  <thead style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "#e9ecef", whiteSpace: "nowrap" }}>
                    <tr className="text-center">
                      <th style={{ width: "60px" }}>{t("Sr No.")}</th>
                      <th style={{ minWidth: "280px" }}>{t("Item Name")}</th>
                      <th style={{ minWidth: "120px" }}>{t("current price")}</th>
                      <th style={{ minWidth: "120px" }}>{t("request stock")}</th>
                      <th style={{ minWidth: "120px" }}>{t("total price")}</th>
                      <th>{t("Remarks")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {edit?.request_stock?.new_request_stock.map((itm, idx) => (
                      <tr key={idx} className="align-middle">
                        <td className="text-center">{idx + 1}</td>
                        <td>
                            <div className="d-flex align-items-center">
                              <ImageViewer
                                src={
                                  itm?.item_image
                                    ? `${process.env.REACT_APP_API_URL}/${itm?.item_image}`
                                    : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                }
                              >
                                <img
                                  src={
                                    itm?.item_image
                                      ? `${process.env.REACT_APP_API_URL}/${itm?.item_image}`
                                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                  }
                                  className="avatar me-2"
                                />
                              </ImageViewer>
                              <span className="small d-grid">
                                <span>{itm.item_name?.label}</span>
                                <span className="text-gray">
                                  {itm?.title?.label}
                                </span>
                              </span>
                            </div>
                        </td>
                        {/* {edit?.request_tax_type == "1" ? (
                        <>
                          <td>{itm.gst_id?.label}</td>
                          <td>{itm.gst_percent}</td>
                        </>
                      ) : null} */}
                        <td>{itm?.rate != null ? formatAmountINR(itm?.rate) : "--"}</td>
                        <td>{itm?.qty != null ? to3(itm?.qty) : "--"}</td>
                        <td>{formatAmountINR(itm?.rate * itm?.qty)}</td>
                        <td>
                          <ItemRemarksCell remarks={itemRemarks} path={`0:new_request_stock:${idx}`} stages={["raised", "approved", "transferred"]} canEdit={canEditTransfer} canEditTransfer={canEditTransfer} />
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={edit?.request_tax_type == "1" ? 3 : 4}></td>
                      <td colSpan={1}>
                        {t("total request qty")}-{" "}
                        <b className="text-start ">
                          {to3(edit?.total_new_request_quantity ?? 0)}{" "}
                        </b>
                      </td>
                      <td className=" fs-6">
                        {formatAmountINR(edit?.total_sum_of_new_request_stock)}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={edit?.request_tax_type == "1" ? 3 : 4}></td>
                      <td className="text-start">
                        {t("Final quantity")}-{" "}
                        <b className="text-start fs-6">
                          {to3(edit?.total_sum_of_quantity)}
                        </b>
                      </td>
                      <td className="fw-bold fs-5">
                        {formatAmountINR(edit?.total_sum_of_request_stock)}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        )}

        {/* -----------Approved Field------------- */}

        {/* {edit?.approved_data?.length > 0 && (
          <Col md={12}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary">
                {t("Approved Stock Field")}
              </strong>
              <div className="mt-2">
                <table className="table-sm table">
                  <tbody>
                    <tr>
                      <th>{t("Status")} :</th>
                      <td style={{ color: statusColor }}>{statusText}</td>
                    </tr>
                    <tr>
                      <th>{t("request tax type")} :</th>
                      <td>
                        {edit?.request_tax_type == "1"
                          ? "Item Wise"
                          : "Overall Price"}
                      </td>
                    </tr>
                    {edit?.request_tax_type == "2" ? (
                      <>
                        <tr>
                          <th>{t("Gst Type")} :</th>
                          <td>{edit?.gst_type}</td>
                        </tr>
                        <tr>
                          <th>{t("Gst %")} :</th>
                          <td>{edit?.gst_percent}</td>
                        </tr>
                      </>
                    ) : null}
                    <tr>
                      <th className="align-middle">{t("Requested For")} :</th>
                      <td>
                        <ImageViewer
                          src={
                            edit.requested_for_image
                              ? `${process.env.REACT_APP_API_URL}${edit.requested_for_image}`
                              : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                          }
                        >
                          <img
                            width={35}
                            height={35}
                            className="my-bg object-fit p-1 rounded-circle"
                            src={
                              edit.requested_for_image
                                ? `${process.env.REACT_APP_API_URL}${edit.requested_for_image}`
                                : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                            }
                          />{" "}
                        </ImageViewer>
                        {edit?.requested_for_name} -{" "}
                        {edit?.requested_for_employee_id}
                      </td>
                    </tr>
                    <tr>
                      <th>{t("request date")} :</th>
                      <td>{edit?.request_date}</td>
                    </tr>
                    <tr>
                      <th className="align-middle">
                        {t("Uploaded bill image")} :
                      </th>
                      <td>
                        <ImageViewer
                          src={
                            edit.request_stock_images?.[0]?.item_image
                              ? `${process.env.REACT_APP_API_URL}${edit?.request_stock_images?.[0]?.item_image}`
                              : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                          }
                        >
                          <img
                            width={50}
                            height={50}
                            className="my-bg object-fit p-1 rounded"
                            src={
                              edit.request_stock_images?.[0]?.item_image
                                ? `${process.env.REACT_APP_API_URL}${edit?.request_stock_images?.[0]?.item_image}`
                                : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                            }
                          />{" "}
                        </ImageViewer>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Col>
        )} */}

        {/* -----------Approved Field old item ------------- */}

        {edit?.approved_data?.[0]?.request_stock?.length > 0 && (
          <Col md={12}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary d-block mb-2" style={{ fontSize: "16px", borderBottom: "2px solid #e9ecef", paddingBottom: "8px" }}>{t("Approved Item")}</strong>
              <div className="mt-2" style={{ overflowX: "auto", maxHeight: "400px", overflowY: "auto" }}>
                <Table className="table Roles table-bordered text-nowrap" style={{ minWidth: "1800px" }}>
                  <thead style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "#e9ecef", whiteSpace: "nowrap" }}>
                    <tr className="text-center">
                      <th style={{ width: "60px" }}>{t("Sr No.")}</th>
                      <th style={{ minWidth: "280px" }}>{t("Item Name")}</th>
                      <th style={{ minWidth: "100px" }}>{t("HSN Code")}</th>
                      <th style={{ minWidth: "100px" }}>{t("Brand")}</th>
                      {edit?.request_tax_type == "1" ? (
                        <>
                          <th style={{ minWidth: "90px" }}>{t("Gst Type")}</th>
                          <th style={{ minWidth: "70px" }}>{t("Gst %")}</th>
                        </>
                      ) : null}
                      <th style={{ minWidth: "110px" }}>{t("Prev user stock")}</th>
                      <th style={{ minWidth: "110px" }}>{t("prev item price")}</th>
                      <th style={{ minWidth: "110px" }}>{t("Request price")}</th>
                      <th style={{ minWidth: "110px" }}>{t("request Quantity")}</th>
                      <th style={{ minWidth: "110px" }}>{t("Approved price")}</th>
                      <th style={{ minWidth: "120px" }}>{t("Approved Quantity")}</th>
                      <th style={{ minWidth: "100px" }}>{t("Lowest Rate")}</th>
                      <th style={{ minWidth: "120px" }}>{t("Supplier")}</th>
                      <th style={{ minWidth: "100px" }}>{t("total price")}</th>
                      <th style={{ width: "70px" }}>{t("Action")}</th>
                      <th>{t("Remarks")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {edit?.approved_data?.[0]?.request_stock?.map(
                      (itm, idx) => (
                        <React.Fragment key={idx}>
                        <tr className="align-middle">
                          <td className="text-center">{idx + 1}</td>
                          <td>
                              <div className="d-flex align-items-center">
                                <ImageViewer
                                  src={
                                    itm.item_name?.image
                                      ? `${process.env.REACT_APP_API_URL}/${itm.item_name?.image}`
                                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                  }
                                >
                                  <img
                                    src={
                                      itm.item_name?.image
                                        ? `${process.env.REACT_APP_API_URL}/${itm.item_name?.image}`
                                        : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                    }
                                    className="avatar me-2"
                                  />
                                </ImageViewer>
                                <span className="small d-grid">
                                  <span>{itm.item_name?.label}</span>
                                  <span className="text-gray">
                                    {itm.item_name?.unique_id
                                      ? `(${itm.item_name?.unique_id})`
                                      : "-"}
                                  </span>
                                </span>
                              </div>
                          </td>
                          <td>{itm.item_name?.hsncode || "-"}</td>
                          <td>{itm.rate?.label || "-"}</td>
                          {edit?.request_tax_type == "1" ? (
                            <>
                              <td>{itm.gst_id?.label ?? "--"}</td>
                              <td>{itm?.gst_percent ?? "--"}</td>
                            </>
                          ) : null}
                          <td>{to3(itm?.prev_user_stock)}</td>
                          <td>{formatAmountINR(itm?.prev_item_price)}</td>
                          <td>{formatAmountINR(itm?.current_item_price)}</td>
                          <td>{to3(itm?.request_quantity)}</td>
                          <td>{formatAmountINR(itm?.approve_price)}</td>
                          <td>{to3(itm?.approve_quantity)}</td>
                          <td>
                            {(() => {
                              const prices = lowPrice[itm.item_name?.hsncode];
                              if (!prices || prices.length === 0) return "-";
                              const minItem = prices.reduce((min, item) =>
                                !min || +item.item_rate < +min.item_rate ? item : min, null
                              );
                              return minItem ? formatAmountINR(minItem.item_rate) : "-";
                            })()}
                          </td>
                          <td>
                            {(() => {
                              const prices = lowPrice[itm.item_name?.hsncode];
                              if (!prices || prices.length === 0) return "-";
                              const minItem = prices.reduce((min, item) =>
                                !min || +item.item_rate < +min.item_rate ? item : min, null
                              );
                              return minItem?.supplier_name || "-";
                            })()}
                          </td>
                          <td>
                            {formatAmountINR(
                              itm?.approve_price * itm?.approve_quantity
                            )}
                          </td>
                          <td className="text-center">
                            <span
                              className={`cursor-pointer text-${
                                collapsedRows.includes(`approved_${idx}`) ? "danger" : "green"
                              }`}
                              onClick={() => toggleRow(`approved_${idx}`)}
                            >
                              {collapsedRows.includes(`approved_${idx}`) ? (
                                <BsDashLg fontSize={"large"} />
                              ) : (
                                <BsPlusLg fontSize={"large"} />
                              )}
                            </span>
                          </td>
                          <td>
                            <ItemRemarksCell remarks={itemRemarks} path={`0:request_stock:${idx}`} stages={["raised", "approved", "transferred"]} canEdit={canEditTransfer} canEditTransfer={canEditTransfer} />
                          </td>
                        </tr>
                        {collapsedRows.includes(`approved_${idx}`) && (
                          <tr>
                            <td className="text-start" colSpan="16" style={{ backgroundColor: "#f0f7ff", padding: "10px" }}>
                              <span className="fw-bold text-primary">{t("Description")}:</span>{" "}
                              {itm.description}
                            </td>
                          </tr>
                        )}
                        </React.Fragment>
                      )
                    )}
                    <tr>
                      <td colSpan={6}></td>
                      <td colSpan={1}>total</td>
                      <td className="text-start ">
                        <b>
                          {to3(edit?.approved_data?.[0]?.request_stock.reduce(
                            (userTotal, item) =>
                              userTotal + item?.approve_quantity,
                            0
                          ))}
                        </b>
                      </td>

                      <td className="text-start">
                        <b>
                          {formatAmountINR(edit?.approved_data?.[0]?.request_stock
                            .reduce(
                              (userTotal, item) =>
                                userTotal +
                                item?.approve_quantity * item?.approve_price,
                              0
                            ))}
                        </b>
                      </td>
                    </tr>

                    {/* <tr>
                    <td colSpan={7}></td>
                    <td colSpan={1}>total gst amount</td>
                    <td className="fw-bold">{edit?.total_gst_amount}</td>
                  </tr> */}
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        )}

        {/* -----------Approved Field New item ------------- */}

        {edit?.approved_data?.[0]?.new_request_stock?.length > 0 && (
          <Col md={12}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary d-block mb-2" style={{ fontSize: "16px", borderBottom: "2px solid #e9ecef", paddingBottom: "8px" }}>
                {t("Approved New Item")}
              </strong>
              <div className="mt-2" style={{ overflowX: "auto", maxHeight: "400px", overflowY: "auto" }}>
                <Table className="table Roles table-bordered text-nowrap" style={{ minWidth: "800px" }}>
                  <thead style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "#e9ecef", whiteSpace: "nowrap" }}>
                    <tr className="text-center">
                      <th style={{ width: "60px" }}>{t("Sr No.")}</th>
                      <th style={{ minWidth: "280px" }}>{t("Item Name")}</th>
                      <th style={{ minWidth: "120px" }}>{t("request rate")}</th>
                      <th style={{ minWidth: "130px" }}>{t("request quantity")}</th>
                      <th style={{ minWidth: "120px" }}>{t("Approved rate")}</th>
                      <th style={{ minWidth: "140px" }}>{t("Approved quantity")}</th>
                      <th style={{ minWidth: "120px" }}>{t("total price")}</th>
                      <th style={{ width: "70px" }}>{t("Action")}</th>
                      <th>{t("Remarks")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {edit?.approved_data?.[0]?.new_request_stock?.map(
                      (itm, idx) => (
                        <React.Fragment key={idx}>
                        <tr className="align-middle">
                          <td className="text-center">{idx + 1}</td>
                          <td>
                              <div className="d-flex align-items-center">
                                <ImageViewer
                                  src={
                                    itm.item_image
                                      ? `${process.env.REACT_APP_API_URL}/${itm?.item_image}`
                                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                  }
                                >
                                  <img
                                    src={
                                      itm?.item_image
                                        ? `${process.env.REACT_APP_API_URL}/${itm.item_image}`
                                        : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                    }
                                    className="avatar me-2"
                                  />
                                </ImageViewer>
                                <span className="small d-grid">
                                  <span>{itm.title?.label}</span>
                                </span>
                              </div>
                          </td>
                          {/* {edit?.request_tax_type == "1" ? (
                          <>
                            <td>{itm.gst_id?.label ?? "--"}</td>
                            <td>{itm?.gst_percent ?? "--"}</td>
                          </>
                        ) : null}
                        <td>{itm.prev_user_stock}</td> */}
                          <td>{formatAmountINR(itm?.requested_rate)}</td>
                          <td>{to3(itm?.requested_qty)}</td>
                          <td>{formatAmountINR(itm?.rate)}</td>
                          <td>{to3(itm?.qty)}</td>

                          <td>{formatAmountINR(itm?.rate * itm?.qty)}</td>
                          <td className="text-center">
                            <span
                              className={`cursor-pointer text-${
                                collapsedRows.includes(`approvedNew_${idx}`) ? "danger" : "green"
                              }`}
                              onClick={() => toggleRow(`approvedNew_${idx}`)}
                            >
                              {collapsedRows.includes(`approvedNew_${idx}`) ? (
                                <BsDashLg fontSize={"large"} />
                              ) : (
                                <BsPlusLg fontSize={"large"} />
                              )}
                            </span>
                          </td>
                          <td>
                            <ItemRemarksCell remarks={itemRemarks} path={`0:new_request_stock:${idx}`} stages={["raised", "approved", "transferred"]} canEdit={canEditTransfer} canEditTransfer={canEditTransfer} />
                          </td>
                        </tr>
                        {collapsedRows.includes(`approvedNew_${idx}`) && (
                          <tr>
                            <td className="text-start" colSpan="8" style={{ backgroundColor: "#f0f7ff", padding: "10px" }}>
                              <span className="fw-bold text-primary">{t("Description")}:</span>{" "}
                              {itm.description}
                            </td>
                          </tr>
                        )}
                        </React.Fragment>
                      )
                    )}
                    <tr>
                      <td colSpan={6}></td>
                      <td colSpan={1}>
                        {t("total")}{" "}
                        <span className="text-start ">
                          {" "}
                          {to3(edit?.approved_data?.[0]?.new_request_stock.reduce(
                            (userTotal, item) => userTotal + +item?.qty,
                            0
                          ))}{" "}
                        </span>
                      </td>

                      <td className="text-start ">
                        <b>
                          {formatAmountINR(edit?.approved_data?.[0]?.new_request_stock.reduce(
                            (userTotal, item) =>
                              userTotal + item?.rate * item?.qty,
                            0
                          ))}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        )}

        {/* -----------Transfer  Field------------- */}

        {/* {(edit?.transfer_stocks?.request_stock.length > 0 ||
          edit?.transfer_stocks?.new_request_stock.length > 0) && (
          <Col md={12}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary">
                {t("Transfer Stock Field")}
              </strong>
              <div className="mt-2">
                <table className="table-sm table">
                  <tbody>
                    <tr>
                      <th>{t("Status")} :</th>
                      <td style={{ color: statusColor }}>{statusText}</td>
                    </tr>
                    <tr>
                      <th>{t("request tax type")} :</th>
                      <td>
                        {edit?.request_tax_type == "1"
                          ? "Item Wise"
                          : "Overall Price"}
                      </td>
                    </tr>
                    {edit?.request_tax_type == "2" ? (
                      <>
                        <tr>
                          <th>{t("Gst Type")} :</th>
                          <td>{edit?.gst_type}</td>
                        </tr>
                        <tr>
                          <th>{t("Gst %")} :</th>
                          <td>{edit?.gst_percent}</td>
                        </tr>
                      </>
                    ) : null}
                    <tr>
                      <th className="align-middle">{t("Requested For")} :</th>
                      <td>
                        <ImageViewer
                          src={
                            edit.requested_for_image
                              ? `${process.env.REACT_APP_API_URL}${edit.requested_for_image}`
                              : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                          }
                        >
                          <img
                            width={35}
                            height={35}
                            className="my-bg object-fit p-1 rounded-circle"
                            src={
                              edit.requested_for_image
                                ? `${process.env.REACT_APP_API_URL}${edit.requested_for_image}`
                                : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                            }
                          />{" "}
                        </ImageViewer>
                        {edit?.requested_for_name} -{" "}
                        {edit?.requested_for_employee_id}
                      </td>
                    </tr>
                    <tr>
                      <th>{t("request date")} :</th>
                      <td>{edit?.request_date}</td>
                    </tr>
                    <tr>
                      <th className="align-middle">
                        {t("Uploaded bill image")} :
                      </th>
                      <td>
                        <ImageViewer
                          src={
                            edit.request_stock_images?.[0]?.item_image
                              ? `${process.env.REACT_APP_API_URL}${edit?.request_stock_images?.[0]?.item_image}`
                              : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                          }
                        >
                          <img
                            width={50}
                            height={50}
                            className="my-bg object-fit p-1 rounded"
                            src={
                              edit.request_stock_images?.[0]?.item_image
                                ? `${process.env.REACT_APP_API_URL}${edit?.request_stock_images?.[0]?.item_image}`
                                : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                            }
                          />{" "}
                        </ImageViewer>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Col>
        )} */}

        {/* -----------Transfer Field old item ------------- */}

        {edit?.transfer_stocks?.request_stock?.length > 0 && (
          <Col md={12}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary d-block mb-2" style={{ fontSize: "16px", borderBottom: "2px solid #e9ecef", paddingBottom: "8px" }}>{t("Transfer Item")}</strong>
              <div className="mt-2" style={{ overflowX: "auto", maxHeight: "400px", overflowY: "auto" }}>
                <Table className="table Roles table-bordered text-nowrap" style={{ minWidth: "1900px" }}>
                  <thead style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "#e9ecef", whiteSpace: "nowrap" }}>
                    <tr className="text-center">
                      <th style={{ width: "60px" }}>{t("Sr No.")}</th>
                      <th style={{ minWidth: "280px" }}>{t("Item Name")}</th>
                      <th style={{ minWidth: "100px" }}>{t("HSN Code")}</th>
                      <th style={{ minWidth: "100px" }}>{t("Brand")}</th>
                      {edit?.request_tax_type == "1" ? (
                        <>
                          <th style={{ minWidth: "90px" }}>{t("Gst Type")}</th>
                          <th style={{ minWidth: "70px" }}>{t("Gst %")}</th>
                        </>
                      ) : null}
                      <th style={{ minWidth: "110px" }}>{t("Prev user stock")}</th>
                      <th style={{ minWidth: "110px" }}>{t("prev item price")}</th>
                      <th style={{ minWidth: "110px" }}>{t("request price")}</th>
                      <th style={{ minWidth: "110px" }}>{t("request Quantity")}</th>
                      <th style={{ minWidth: "110px" }}>{t("Approved price")}</th>
                      <th style={{ minWidth: "120px" }}>{t("Approved Quantity")}</th>
                      <th style={{ minWidth: "100px" }}>{t("Lowest Rate")}</th>
                      <th style={{ minWidth: "120px" }}>{t("Supplier")}</th>
                      <th style={{ minWidth: "120px" }}>{t("Transfer Quantity")}</th>
                      <th style={{ minWidth: "100px" }}>{t("total price")}</th>
                      <th style={{ width: "70px" }}>{t("Action")}</th>
                      <th>{t("Remarks")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {edit?.transfer_stocks?.request_stock?.map((itm, idx) => (
                      <React.Fragment key={idx}>
                      <tr className="align-middle">
                        <td className="text-center">{idx + 1}</td>
                        <td>
                            <div className="d-flex align-items-center">
                              <ImageViewer
                                src={
                                  itm.item_name?.image
                                    ? `${process.env.REACT_APP_API_URL}/${itm.item_name?.image}`
                                    : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                }
                              >
                                <img
                                  src={
                                    itm.item_name?.image
                                      ? `${process.env.REACT_APP_API_URL}/${itm.item_name?.image}`
                                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                  }
                                  className="avatar me-2"
                                />
                              </ImageViewer>
                              <span className="small d-grid">
                                <span>{itm.item_name?.label}</span>
                                <span className="text-gray">
                                  {itm.item_name?.unique_id
                                    ? `(${itm.item_name?.unique_id})`
                                    : "-"}
                                </span>
                              </span>
                            </div>
                        </td>
                        <td>{itm.item_name?.hsncode || "-"}</td>
                        <td>{itm.rate?.label || "-"}</td>
                        {edit?.request_tax_type == "1" ? (
                          <>
                            <td>{itm.gst_id?.label ?? "--"}</td>
                            <td>{itm?.gst_percent ?? "--"}</td>
                          </>
                        ) : null}
                        <td>{to3(itm?.prev_user_stock)}</td>
                        <td>{formatAmountINR(itm?.prev_item_price)}</td>
                        <td>{formatAmountINR(itm?.current_item_price)}</td>
                        <td>{to3(itm?.request_quantity)}</td>
                        <td>{formatAmountINR(itm?.approve_price)}</td>
                        <td>{to3(itm?.approve_quantity)}</td>
                        <td>
                          {(() => {
                            const prices = lowPrice[itm.item_name?.hsncode];
                            if (!prices || prices.length === 0) return "-";
                            const minItem = prices.reduce((min, item) =>
                              !min || +item.item_rate < +min.item_rate ? item : min, null
                            );
                            return minItem ? formatAmountINR(minItem.item_rate) : "-";
                          })()}
                        </td>
                        <td>
                          {(() => {
                            const prices = lowPrice[itm.item_name?.hsncode];
                            if (!prices || prices.length === 0) return "-";
                            const minItem = prices.reduce((min, item) =>
                              !min || +item.item_rate < +min.item_rate ? item : min, null
                            );
                            return minItem?.supplier_name || "-";
                          })()}
                        </td>
                        <td>{itm?.transfer_qty != null ? to3(itm?.transfer_qty) : "--"}</td>
                        <td>
                          {formatAmountINR(itm?.approve_price * itm?.transfer_qty)}
                        </td>
                        <td className="text-center">
                          <span
                            className={`cursor-pointer text-${
                              collapsedRows.includes(`transfer_${idx}`) ? "danger" : "green"
                            }`}
                            onClick={() => toggleRow(`transfer_${idx}`)}
                          >
                            {collapsedRows.includes(`transfer_${idx}`) ? (
                              <BsDashLg fontSize={"large"} />
                            ) : (
                              <BsPlusLg fontSize={"large"} />
                            )}
                          </span>
                        </td>
                        <td>
                          <ItemRemarksCell remarks={itemRemarks} path={`0:request_stock:${idx}`} stages={["raised", "approved", "transferred"]} canEdit={canEditTransfer} canEditTransfer={canEditTransfer} />
                        </td>
                      </tr>
                      {collapsedRows.includes(`transfer_${idx}`) && (
                        <tr>
                          <td className="text-start" colSpan="17" style={{ backgroundColor: "#f0f7ff", padding: "10px" }}>
                            <span className="fw-bold text-primary">{t("Description")}:</span>{" "}
                            {itm.description}
                          </td>
                        </tr>
                      )}
                      </React.Fragment>
                    ))}
                    <tr>
                      <td colSpan={7}></td>
                      <td colSpan={1}>{t("total")}</td>
                      <td className="text-start ">
                        <b>
                          {to3(edit?.transfer_stocks?.request_stock.reduce(
                            (userTotal, item) => userTotal + item?.transfer_qty,
                            0
                          ))}
                        </b>
                      </td>

                      <td className="text-start ">
                        <b>
                          {formatAmountINR(edit?.transfer_stocks?.request_stock
                            .reduce(
                              (userTotal, item) =>
                                userTotal +
                                item?.transfer_qty * item?.approve_price,
                              0
                            ))}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        )}

        {/* -----------Transfer Field New item ------------- */}

        {edit?.transfer_stocks?.new_request_stock?.length > 0 && (
          <Col md={12}>
            <div className="p-20 shadow rounded h-100">
              <strong className="text-secondary d-block mb-2" style={{ fontSize: "16px", borderBottom: "2px solid #e9ecef", paddingBottom: "8px" }}>
                {t("Transfer New Item")}
              </strong>
              <div className="mt-2" style={{ overflowX: "auto", maxHeight: "400px", overflowY: "auto" }}>
                <Table className="table Roles table-bordered text-nowrap" style={{ minWidth: "900px" }}>
                  <thead style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "#e9ecef", whiteSpace: "nowrap" }}>
                    <tr className="text-center">
                      <th style={{ width: "60px" }}>{t("Sr No.")}</th>
                      <th style={{ minWidth: "280px" }}>{t("Item Name")}</th>
                      <th style={{ minWidth: "120px" }}>{t("request rate")}</th>
                      <th style={{ minWidth: "130px" }}>{t("request quantity")}</th>
                      <th style={{ minWidth: "120px" }}>{t("Approved rate")}</th>
                      <th style={{ minWidth: "140px" }}>{t("Approved quantity")}</th>
                      <th style={{ minWidth: "140px" }}>{t("Transfer quantity")}</th>
                      <th style={{ minWidth: "120px" }}>{t("total price")}</th>
                      <th style={{ width: "70px" }}>{t("Action")}</th>
                      <th>{t("Remarks")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {edit?.transfer_stocks?.new_request_stock?.map(
                      (itm, idx) => (
                        <React.Fragment key={idx}>
                        <tr className="align-middle">
                          <td className="text-center">{idx + 1}</td>
                          <td>
                              <div className="d-flex align-items-center">
                                <ImageViewer
                                  src={
                                    itm.item_image
                                      ? `${process.env.REACT_APP_API_URL}/${itm?.item_image}`
                                      : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                  }
                                >
                                  <img
                                    src={
                                      itm?.item_image
                                        ? `${process.env.REACT_APP_API_URL}/${itm.item_image}`
                                        : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
                                    }
                                    className="avatar me-2"
                                  />
                                </ImageViewer>
                                <span className="small d-grid">
                                  <span>{itm.title?.label}</span>
                                </span>
                              </div>
                          </td>
                          {/* {edit?.request_tax_type == "1" ? (
                          <>
                            <td>{itm.gst_id?.label ?? "--"}</td>
                            <td>{itm?.gst_percent ?? "--"}</td>
                          </>
                        ) : null}
                        <td>{itm.prev_user_stock}</td> */}
                          <td>{formatAmountINR(itm?.requested_rate)}</td>
                          <td>{to3(itm?.requested_qty)}</td>
                          <td>{formatAmountINR(itm?.rate)}</td>
                          <td>{to3(itm?.qty)}</td>
                          <td>{to3(itm?.transfer_qty)}</td>
                          <td>{formatAmountINR(itm?.rate * itm?.qty)}</td>
                          <td className="text-center">
                            <span
                              className={`cursor-pointer text-${
                                collapsedRows.includes(`transferNew_${idx}`) ? "danger" : "green"
                              }`}
                              onClick={() => toggleRow(`transferNew_${idx}`)}
                            >
                              {collapsedRows.includes(`transferNew_${idx}`) ? (
                                <BsDashLg fontSize={"large"} />
                              ) : (
                                <BsPlusLg fontSize={"large"} />
                              )}
                            </span>
                          </td>
                          <td>
                            <ItemRemarksCell remarks={itemRemarks} path={`0:new_request_stock:${idx}`} stages={["raised", "approved", "transferred"]} canEdit={canEditTransfer} canEditTransfer={canEditTransfer} />
                          </td>
                        </tr>
                        {collapsedRows.includes(`transferNew_${idx}`) && (
                          <tr>
                            <td className="text-start" colSpan="9" style={{ backgroundColor: "#f0f7ff", padding: "10px" }}>
                              <span className="fw-bold text-primary">{t("Description")}:</span>{" "}
                              {itm.description}
                            </td>
                          </tr>
                        )}
                        </React.Fragment>
                      )
                    )}
                    <tr>
                      <td colSpan={edit?.request_tax_type == "1" ? 4 : 4}></td>
                      <td className="fw-bold">{t("total")} </td>
                      <td className="fw-bold">
                        <span className="text-start ">
                          {" "}
                          {to3(edit?.transfer_stocks?.new_request_stock.reduce(
                            (userTotal, item) => userTotal + +item?.qty,
                            0
                          ))}{" "}
                        </span>
                      </td>

                      <td className="text-start ">
                        <b>
                          {formatAmountINR(edit?.transfer_stocks?.new_request_stock.reduce(
                            (userTotal, item) =>
                              userTotal + item?.rate * item?.qty,
                            0
                          ) || 0)}
                        </b>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={5}></td>
                      <td className="text-start fs-6 fw-bold">
                        {t("Final amount")}
                        <span>
                          {formatAmountINR(
                            edit?.transfer_stocks?.new_request_stock.reduce(
                              (userTotal, item) =>
                                userTotal + item?.rate * item?.qty,
                              0
                            ) +
                              edit?.transfer_stocks?.request_stock.reduce(
                                (userTotal, item) =>
                                  userTotal +
                                  item?.transfer_qty * item?.approve_price,
                                0
                              ) || 0
                          )}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        )}
      </Row>
    </>
  );
};
